module.exports = __webpack_public_path__ + "static/media/arrow-icon-full-white-up.4a7416d0.svg";